<template>
  <div class="chart-wrapper" :style="{ height: 46 }">
    <v-chart
      :force-fit="true"
      :height="height"
      :data="dataSource"
      :padding="chartConfig.padding"
      :scale="scale"
    >
      <v-tooltip />
      <!-- X 轴 -->
      <v-axis v-if="showXAxis" dataKey="x" :visible="true" />
      <!-- ✅ 强制隐藏 Y 轴 -->
      <v-axis
        v-if="showXAxis"
        dataKey="y"
        :visible="false"
        :line="false"
        :tickLine="false"
        :label="false"
        :grid="false"
      />

      <v-smooth-area position="x*y" />
      <v-smooth-line position="x*y" :label="label2" />
      <v-point position="x*y" shape="circle" />
    </v-chart>
  </div>
</template>

<script>
export default {
  name: 'MiniArea',
  props: {
    dataSource: { type: Array, default: () => [] },
    y: { type: String, default: 'y' },
    showXAxis: { type: Boolean, default: false },
    chartConfig: {
      type: Object,
      default: { height: 100, padding: [36, 20, 18, 20] },
    },
  },
  data() {
    return {
      height: this.chartConfig.height,
      scale: [{ dataKey: 'y', alias: this.y }],
      label2: ['x*y', (x, y) => y],
    }
  },
}
</script>

<style lang="less" scoped>
@import 'chart';
</style>
